import { Button } from "@/components/ui/Button";

interface ConfirmDeleteDialogProps {
  title: string;
  description: string;
  isOpen: boolean;
  isPending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteDialog({ title, description, isOpen, isPending, onCancel, onConfirm }: ConfirmDeleteDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] grid place-items-center bg-black/75 px-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-md border border-red-300/25 bg-surface p-5 shadow-panel">
        <h2 className="font-display text-2xl font-bold uppercase text-white">{title}</h2>
        <p className="mt-3 text-sm leading-6 text-content-secondary">{description}</p>
        <div className="mt-6 flex justify-end gap-3">
          <Button variant="ghost" onClick={onCancel} disabled={isPending}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isPending}>
            {isPending ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
}
